import { SupportedComponents } from './useProductContent/SupportedComponents';

/*
 * The name of the component to be checked corresponds to the "Block" component in Contentful.
 * The method checks if the main block can be displayed (even if it has some children in it) after the key components of the block.
 * */

const {
  blockExpandableTab,
  blockImagesText,
  blockTextList,
  blockBlockList,
  blockTitle,
  blockEnumeration,
  blockTeaserText,
  blockFullText,
  blockTabsContainer,
  blockCardList,
  blockDoubleTextList,
  blockRankList3Levels,
} = SupportedComponents;

export const UseCheckCanDisplayComponent = ({ component, title, items, cards, tabs }) => {
  switch (component) {
    case blockTabsContainer:
      return tabs?.length ? tabs.some((tab) => tab.fields) : false;
    case blockCardList:
      return cards?.length ? cards.some((card) => card.fields) : false;
    case blockDoubleTextList:
      return items?.length ? items.some((item) => item?.fields?.title) : false;
    case blockRankList3Levels:
      return items?.length ? items.some((item) => item?.fields?.title) : false;
    default:
      return true;
  }
};
